import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './InventoryTab.module.css';
import DTextInput from "../../../components/Dashboard/DashboardInputs/DTextInput";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import classes from "./InventoryTab.module.css";
import DateBar from "../../../components/common/DateBar/DateBar";
import NotificationBell from "../../../components/common/NotificationBell/NotificationBell";
import ProfileCard from "../../../components/common/ProfileCard/ProfileCard";

const InventoryTab = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.loginData.value);

    const [inventoryControlData, setInventoryControlData] = useState([]);
    const [newInventoryControlEntry, setNewInventoryControlEntry] = useState({
        itemCode: '',
        itemName: '',
        sku: '',
        currentStockLevel: '',
        location: '',
        itemCondition: '',
        unitCost: '',
        totalInventoryValue: '',
    });

    const [warehouseManagementData, setWarehouseManagementData] = useState([]);
    const [newWarehouseManagementEntry, setNewWarehouseManagementEntry] = useState({
        warehouseCode: '',
        warehouseLocation: '',
        storageBinCode: '',
        binCapacity: '',
        binStatus: '',
        inventoryTurnoverRate: '',
    });

    const [replenishmentManagementData, setReplenishmentManagementData] = useState([]);
    const [newReplenishmentManagementEntry, setNewReplenishmentManagementEntry] = useState({
        itemCode: '',
        reorderPoint: '',
        reorderQuantity: '',
        safetyStockLevel: '',
        leadTime: '',
        supplierCode: '',
    });

    const [cycleCountingData, setCycleCountingData] = useState([]);
    const [newCycleCountingEntry, setNewCycleCountingEntry] = useState({
        itemCode: '',
        cycleCountFrequency: '',
        lastCountDate: '',
        physicalCountQuantity: '',
        systemQuantity: '',
        variance: '',
    });

    const [inventoryValuationData, setInventoryValuationData] = useState([]);
    const [newInventoryValuationEntry, setNewInventoryValuationEntry] = useState({
        itemCode: '',
        valuationMethod: '',
        unitCost: '',
        totalInventoryValue: '',
        valuationDate: '',
    });

    const [inventoryAdjustmentsData, setInventoryAdjustmentsData] = useState([]);
    const [newInventoryAdjustmentsEntry, setNewInventoryAdjustmentsEntry] = useState({
        adjustmentCode: '',
        itemCode: '',
        adjustmentType: '',
        adjustmentQuantity: '',
        reasonForAdjustment: '',
        adjustmentDate: '',
    });

    const [stockTransferData, setStockTransferData] = useState([]);
    const [newStockTransferEntry, setNewStockTransferEntry] = useState({
        transferCode: '',
        sourceLocation: '',
        destinationLocation: '',
        itemCode: '',
        transferQuantity: '',
        transferDate: '',
        transferStatus: '',
    });

    const [lotTrackingData, setLotTrackingData] = useState([]);
    const [newLotTrackingEntry, setNewLotTrackingEntry] = useState({
        lotNumber: '',
        serialNumber: '',
        itemCode: '',
        warehouseLocation: '',
        expiryDate: '',
        batchNumber: '',
    });

    const [inventoryForecastingData, setInventoryForecastingData] = useState([]);
    const [newInventoryForecastingEntry, setNewInventoryForecastingEntry] = useState({
        itemCode: '',
        forecastedDemand: '',
        forecastPeriod: '',
        historicalSalesData: '',
        trendAnalysis: '',
    });

    const [returnsData, setReturnsData] = useState([]);
    const [newReturnsEntry, setNewReturnsEntry] = useState({
        returnCode: '',
        itemCode: '',
        returnQuantity: '',
        returnReason: '',
        returnDate: '',
        status: '',
    });

    const handleInputChange = (e, setState, state) => {
        const { name, value } = e.target;
        setState({
            ...state,
            [name]: value,
        });
    };

    return (
        <div className={classes.users_tab_wrapper}>
            <div className={classes.users_topHeader}>
                <div className={`${classes.lhs} flex`}>
                    <HeaderTitle titleText="Inventory Management" customclass={classes.dashHead} />
                </div>
            </div>

            <div className={classes.tabsScreens}>
                <div className={classes.infoSection}>
                    <div className={classes.mrpFormWrapper}>
                        <form>
                            <h3 className={classes.subTitle}>Inventory Control</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Item CODE"
                                    value={newInventoryControlEntry.itemCode}
                                    onChange={(e) => handleInputChange(e, setNewInventoryControlEntry, newInventoryControlEntry)}
                                    name="itemCode"
                                />
                                <DTextInput
                                    label="Item Name"
                                    value={newInventoryControlEntry.itemName}
                                    onChange={(e) => handleInputChange(e, setNewInventoryControlEntry, newInventoryControlEntry)}
                                    name="itemName"
                                />
                                <DTextInput
                                    label="Stock Keeping Unit (SKU)"
                                    value={newInventoryControlEntry.sku}
                                    onChange={(e) => handleInputChange(e, setNewInventoryControlEntry, newInventoryControlEntry)}
                                    name="sku"
                                />
                                <DTextInput
                                    label="Current Stock Level"
                                    value={newInventoryControlEntry.currentStockLevel}
                                    onChange={(e) => handleInputChange(e, setNewInventoryControlEntry, newInventoryControlEntry)}
                                    name="currentStockLevel"
                                />
                                <DTextInput
                                    label="Location (Warehouse, Aisle, Bin)"
                                    value={newInventoryControlEntry.location}
                                    onChange={(e) => handleInputChange(e, setNewInventoryControlEntry, newInventoryControlEntry)}
                                    name="location"
                                />
                                <DTextInput
                                    label="Item Condition (New, Used, Damaged)"
                                    value={newInventoryControlEntry.itemCondition}
                                    onChange={(e) => handleInputChange(e, setNewInventoryControlEntry, newInventoryControlEntry)}
                                    name="itemCondition"
                                />
                                <DTextInput
                                    label="Unit Cost"
                                    value={newInventoryControlEntry.unitCost}
                                    onChange={(e) => handleInputChange(e, setNewInventoryControlEntry, newInventoryControlEntry)}
                                    name="unitCost"
                                />
                                <DTextInput
                                    label="Total Inventory Value"
                                    value={newInventoryControlEntry.totalInventoryValue}
                                    onChange={(e) => handleInputChange(e, setNewInventoryControlEntry, newInventoryControlEntry)}
                                    name="totalInventoryValue"
                                />
                            </div>

                            <h3 className={classes.subTitle}>Warehouse Management</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Warehouse CODE"
                                    value={newWarehouseManagementEntry.warehouseCode}
                                    onChange={(e) => handleInputChange(e, setNewWarehouseManagementEntry, newWarehouseManagementEntry)}
                                    name="warehouseCode"
                                />
                                <DTextInput
                                    label="Warehouse Location"
                                    value={newWarehouseManagementEntry.warehouseLocation}
                                    onChange={(e) => handleInputChange(e, setNewWarehouseManagementEntry, newWarehouseManagementEntry)}
                                    name="warehouseLocation"
                                />
                                <DTextInput
                                    label="Storage Bin CODE"
                                    value={newWarehouseManagementEntry.storageBinCode}
                                    onChange={(e) => handleInputChange(e, setNewWarehouseManagementEntry, newWarehouseManagementEntry)}
                                    name="storageBinCode"
                                />
                                <DTextInput
                                    label="Bin Capacity"
                                    value={newWarehouseManagementEntry.binCapacity}
                                    onChange={(e) => handleInputChange(e, setNewWarehouseManagementEntry, newWarehouseManagementEntry)}
                                    name="binCapacity"
                                />
                                <DTextInput
                                    label="Bin Status (Available, Occupied)"
                                    value={newWarehouseManagementEntry.binStatus}
                                    onChange={(e) => handleInputChange(e, setNewWarehouseManagementEntry, newWarehouseManagementEntry)}
                                    name="binStatus"
                                />
                                <DTextInput
                                    label="Inventory Turnover Rate"
                                    value={newWarehouseManagementEntry.inventoryTurnoverRate}
                                    onChange={(e) => handleInputChange(e, setNewWarehouseManagementEntry, newWarehouseManagementEntry)}
                                    name="inventoryTurnoverRate"
                                />
                            </div>

                            <h3 className={classes.subTitle}>Replenishment Management</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Item CODE"
                                    value={newReplenishmentManagementEntry.itemCode}
                                    onChange={(e) => handleInputChange(e, setNewReplenishmentManagementEntry, newReplenishmentManagementEntry)}
                                    name="itemCode"
                                />
                                <DTextInput
                                    label="Reorder Point"
                                    value={newReplenishmentManagementEntry.reorderPoint}
                                    onChange={(e) => handleInputChange(e, setNewReplenishmentManagementEntry, newReplenishmentManagementEntry)}
                                    name="reorderPoint"
                                />
                                <DTextInput
                                    label="Reorder Quantity"
                                    value={newReplenishmentManagementEntry.reorderQuantity}
                                    onChange={(e) => handleInputChange(e, setNewReplenishmentManagementEntry, newReplenishmentManagementEntry)}
                                    name="reorderQuantity"
                                />
                                <DTextInput
                                    label="Safety Stock Level"
                                    value={newReplenishmentManagementEntry.safetyStockLevel}
                                    onChange={(e) => handleInputChange(e, setNewReplenishmentManagementEntry, newReplenishmentManagementEntry)}
                                    name="safetyStockLevel"
                                />
                                <DTextInput
                                    label="Lead Time"
                                    value={newReplenishmentManagementEntry.leadTime}
                                    onChange={(e) => handleInputChange(e, setNewReplenishmentManagementEntry, newReplenishmentManagementEntry)}
                                    name="leadTime"
                                />
                                <DTextInput
                                    label="Supplier CODE"
                                    value={newReplenishmentManagementEntry.supplierCode}
                                    onChange={(e) => handleInputChange(e, setNewReplenishmentManagementEntry, newReplenishmentManagementEntry)}
                                    name="supplierCode"
                                />
                            </div>

                            <h3 className={classes.subTitle}>Cycle Counting and Physical Inventory</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Item CODE"
                                    value={newCycleCountingEntry.itemCode}
                                    onChange={(e) => handleInputChange(e, setNewCycleCountingEntry, newCycleCountingEntry)}
                                    name="itemCode"
                                />
                                <DTextInput
                                    label="Cycle Count Frequency"
                                    value={newCycleCountingEntry.cycleCountFrequency}
                                    onChange={(e) => handleInputChange(e, setNewCycleCountingEntry, newCycleCountingEntry)}
                                    name="cycleCountFrequency"
                                />
                                <DTextInput
                                    label="Last Count Date"
                                    value={newCycleCountingEntry.lastCountDate}
                                    onChange={(e) => handleInputChange(e, setNewCycleCountingEntry, newCycleCountingEntry)}
                                    name="lastCountDate"
                                />
                                <DTextInput
                                    label="Physical Count Quantity"
                                    value={newCycleCountingEntry.physicalCountQuantity}
                                    onChange={(e) => handleInputChange(e, setNewCycleCountingEntry, newCycleCountingEntry)}
                                    name="physicalCountQuantity"
                                />
                                <DTextInput
                                    label="System Quantity"
                                    value={newCycleCountingEntry.systemQuantity}
                                    onChange={(e) => handleInputChange(e, setNewCycleCountingEntry, newCycleCountingEntry)}
                                    name="systemQuantity"
                                />
                                <DTextInput
                                    label="Variance"
                                    value={newCycleCountingEntry.variance}
                                    onChange={(e) => handleInputChange(e, setNewCycleCountingEntry, newCycleCountingEntry)}
                                    name="variance"
                                />
                            </div>

                            <h3 className={classes.subTitle}>Inventory Valuation</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Item CODE"
                                    value={newInventoryValuationEntry.itemCode}
                                    onChange={(e) => handleInputChange(e, setNewInventoryValuationEntry, newInventoryValuationEntry)}
                                    name="itemCode"
                                />
                                <DTextInput
                                    label="Valuation Method"
                                    value={newInventoryValuationEntry.valuationMethod}
                                    onChange={(e) => handleInputChange(e, setNewInventoryValuationEntry, newInventoryValuationEntry)}
                                    name="valuationMethod"
                                />
                                <DTextInput
                                    label="Unit Cost"
                                    value={newInventoryValuationEntry.unitCost}
                                    onChange={(e) => handleInputChange(e, setNewInventoryValuationEntry, newInventoryValuationEntry)}
                                    name="unitCost"
                                />
                                <DTextInput
                                    label="Total Inventory Value"
                                    value={newInventoryValuationEntry.totalInventoryValue}
                                    onChange={(e) => handleInputChange(e, setNewInventoryValuationEntry, newInventoryValuationEntry)}
                                    name="totalInventoryValue"
                                />
                                <DTextInput
                                    label="Valuation Date"
                                    value={newInventoryValuationEntry.valuationDate}
                                    onChange={(e) => handleInputChange(e, setNewInventoryValuationEntry, newInventoryValuationEntry)}
                                    name="valuationDate"
                                />
                            </div>

                            <h3 className={classes.subTitle}>Inventory Adjustments</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Adjustment CODE"
                                    value={newInventoryAdjustmentsEntry.adjustmentCode}
                                    onChange={(e) => handleInputChange(e, setNewInventoryAdjustmentsEntry, newInventoryAdjustmentsEntry)}
                                    name="adjustmentCode"
                                />
                                <DTextInput
                                    label="Item CODE"
                                    value={newInventoryAdjustmentsEntry.itemCode}
                                    onChange={(e) => handleInputChange(e, setNewInventoryAdjustmentsEntry, newInventoryAdjustmentsEntry)}
                                    name="itemCode"
                                />
                                <DTextInput
                                    label="Adjustment Type (Shrinkage, Damage, Error Correction)"
                                    value={newInventoryAdjustmentsEntry.adjustmentType}
                                    onChange={(e) => handleInputChange(e, setNewInventoryAdjustmentsEntry, newInventoryAdjustmentsEntry)}
                                    name="adjustmentType"
                                />
                                <DTextInput
                                    label="Adjustment Quantity"
                                    value={newInventoryAdjustmentsEntry.adjustmentQuantity}
                                    onChange={(e) => handleInputChange(e, setNewInventoryAdjustmentsEntry, newInventoryAdjustmentsEntry)}
                                    name="adjustmentQuantity"
                                />
                                <DTextInput
                                    label="Reason for Adjustment"
                                    value={newInventoryAdjustmentsEntry.reasonForAdjustment}
                                    onChange={(e) => handleInputChange(e, setNewInventoryAdjustmentsEntry, newInventoryAdjustmentsEntry)}
                                    name="reasonForAdjustment"
                                />
                                <DTextInput
                                    label="Adjustment Date"
                                    value={newInventoryAdjustmentsEntry.adjustmentDate}
                                    onChange={(e) => handleInputChange(e, setNewInventoryAdjustmentsEntry, newInventoryAdjustmentsEntry)}
                                    name="adjustmentDate"
                                />
                            </div>

                            <h3 className={classes.subTitle}>Stock Transfer Management</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Transfer CODE"
                                    value={newStockTransferEntry.transferCode}
                                    onChange={(e) => handleInputChange(e, setNewStockTransferEntry, newStockTransferEntry)}
                                    name="transferCode"
                                />
                                <DTextInput
                                    label="Source Location"
                                    value={newStockTransferEntry.sourceLocation}
                                    onChange={(e) => handleInputChange(e, setNewStockTransferEntry, newStockTransferEntry)}
                                    name="sourceLocation"
                                />
                                <DTextInput
                                    label="Destination Location"
                                    value={newStockTransferEntry.destinationLocation}
                                    onChange={(e) => handleInputChange(e, setNewStockTransferEntry, newStockTransferEntry)}
                                    name="destinationLocation"
                                />
                                <DTextInput
                                    label="Item CODE"
                                    value={newStockTransferEntry.itemCode}
                                    onChange={(e) => handleInputChange(e, setNewStockTransferEntry, newStockTransferEntry)}
                                    name="itemCode"
                                />
                                <DTextInput
                                    label="Transfer Quantity"
                                    value={newStockTransferEntry.transferQuantity}
                                    onChange={(e) => handleInputChange(e, setNewStockTransferEntry, newStockTransferEntry)}
                                    name="transferQuantity"
                                />
                                <DTextInput
                                    label="Transfer Date"
                                    value={newStockTransferEntry.transferDate}
                                    onChange={(e) => handleInputChange(e, setNewStockTransferEntry, newStockTransferEntry)}
                                    name="transferDate"
                                />
                                <DTextInput
                                    label="Transfer Status"
                                    value={newStockTransferEntry.transferStatus}
                                    onChange={(e) => handleInputChange(e, setNewStockTransferEntry, newStockTransferEntry)}
                                    name="transferStatus"
                                />
                            </div>

                            <h3 className={classes.subTitle}>Lot and Serial Number Tracking</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Lot Number"
                                    value={newLotTrackingEntry.lotNumber}
                                    onChange={(e) => handleInputChange(e, setNewLotTrackingEntry, newLotTrackingEntry)}
                                    name="lotNumber"
                                />
                                <DTextInput
                                    label="Serial Number"
                                    value={newLotTrackingEntry.serialNumber}
                                    onChange={(e) => handleInputChange(e, setNewLotTrackingEntry, newLotTrackingEntry)}
                                    name="serialNumber"
                                />
                                <DTextInput
                                    label="Item CODE"
                                    value={newLotTrackingEntry.itemCode}
                                    onChange={(e) => handleInputChange(e, setNewLotTrackingEntry, newLotTrackingEntry)}
                                    name="itemCode"
                                />
                                <DTextInput
                                    label="Warehouse Location"
                                    value={newLotTrackingEntry.warehouseLocation}
                                    onChange={(e) => handleInputChange(e, setNewLotTrackingEntry, newLotTrackingEntry)}
                                    name="warehouseLocation"
                                />
                                <DTextInput
                                    label="Expiry Date"
                                    value={newLotTrackingEntry.expiryDate}
                                    onChange={(e) => handleInputChange(e, setNewLotTrackingEntry, newLotTrackingEntry)}
                                    name="expiryDate"
                                />
                                <DTextInput
                                    label="Batch Number"
                                    value={newLotTrackingEntry.batchNumber}
                                    onChange={(e) => handleInputChange(e, setNewLotTrackingEntry, newLotTrackingEntry)}
                                    name="batchNumber"
                                />
                            </div>

                            <h3 className={classes.subTitle}>Inventory Forecasting</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Item CODE"
                                    value={newInventoryForecastingEntry.itemCode}
                                    onChange={(e) => handleInputChange(e, setNewInventoryForecastingEntry, newInventoryForecastingEntry)}
                                    name="itemCode"
                                />
                                <DTextInput
                                    label="Forecasted Demand"
                                    value={newInventoryForecastingEntry.forecastedDemand}
                                    onChange={(e) => handleInputChange(e, setNewInventoryForecastingEntry, newInventoryForecastingEntry)}
                                    name="forecastedDemand"
                                />
                                <DTextInput
                                    label="Forecast Period"
                                    value={newInventoryForecastingEntry.forecastPeriod}
                                    onChange={(e) => handleInputChange(e, setNewInventoryForecastingEntry, newInventoryForecastingEntry)}
                                    name="forecastPeriod"
                                />
                                <DTextInput
                                    label="Historical Sales Data"
                                    value={newInventoryForecastingEntry.historicalSalesData}
                                    onChange={(e) => handleInputChange(e, setNewInventoryForecastingEntry, newInventoryForecastingEntry)}
                                    name="historicalSalesData"
                                />
                                <DTextInput
                                    label="Trend Analysis"
                                    value={newInventoryForecastingEntry.trendAnalysis}
                                    onChange={(e) => handleInputChange(e, setNewInventoryForecastingEntry, newInventoryForecastingEntry)}
                                    name="trendAnalysis"
                                />
                            </div>

                            <h3 className={classes.subTitle}>Returns and Reverse Logistics</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Return CODE"
                                    value={newReturnsEntry.returnCode}
                                    onChange={(e) => handleInputChange(e, setNewReturnsEntry, newReturnsEntry)}
                                    name="returnCode"
                                />
                                <DTextInput
                                    label="Item CODE"
                                    value={newReturnsEntry.itemCode}
                                    onChange={(e) => handleInputChange(e, setNewReturnsEntry, newReturnsEntry)}
                                    name="itemCode"
                                />
                                <DTextInput
                                    label="Return Quantity"
                                    value={newReturnsEntry.returnQuantity}
                                    onChange={(e) => handleInputChange(e, setNewReturnsEntry, newReturnsEntry)}
                                    name="returnQuantity"
                                />
                                <DTextInput
                                    label="Return Reason"
                                    value={newReturnsEntry.returnReason}
                                    onChange={(e) => handleInputChange(e, setNewReturnsEntry, newReturnsEntry)}
                                    name="returnReason"
                                />
                                <DTextInput
                                    label="Return Date"
                                    value={newReturnsEntry.returnDate}
                                    onChange={(e) => handleInputChange(e, setNewReturnsEntry, newReturnsEntry)}
                                    name="returnDate"
                                />
                                <DTextInput
                                    label="Status (Pending, Approved, Completed)"
                                    value={newReturnsEntry.status}
                                    onChange={(e) => handleInputChange(e, setNewReturnsEntry, newReturnsEntry)}
                                    name="status"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InventoryTab;